<script  context="module">import { isValidElement } from "../internal/elements";
import { get_current_component } from "svelte/internal";
export var RenderStrategy;
(function (RenderStrategy) {
    RenderStrategy[RenderStrategy["Unmount"] = 0] = "Unmount";
    RenderStrategy[RenderStrategy["Hidden"] = 1] = "Hidden";
})(RenderStrategy || (RenderStrategy = {}));
</script>

<script >import { useActions } from "../hooks/use-actions";
import { forwardEventsBuilder } from "../internal/forwardEventsBuilder";
import { Features } from "../types";
const forwardEvents = forwardEventsBuilder(get_current_component());
export let name;
export let as;
export let slotProps;
export let el = null;
export let use = [];
export let visible = true;
export let features = Features.None;
// The static and unmount props are only used in conjunction with the render strategies
export let unmount = true;
let static_ = false;
export { static_ as static };
let classProp = undefined;
export { classProp as class };
// This is not in upstream Headless UI, but we might as well add it here
export let style = undefined;
if (!as) {
    throw new Error(`<${name}> did not provide an \`as\` value to <Render>`);
}
if (!isValidElement(as)) {
    throw new Error(`<${name}> has an invalid or unsupported \`as\` prop: ${as}`);
}
$: computedClass =
    typeof classProp === "function" ? classProp(slotProps) : classProp;
$: computedStyle = typeof style === "function" ? style(slotProps) : style;
$: show =
    visible ||
        (features & Features.Static && static_) ||
        !(features & Features.RenderStrategy && unmount);
$: hidden =
    !visible &&
        !(features & Features.Static && static_) &&
        features & Features.RenderStrategy &&
        !unmount;
$: propsWeControl = {
    class: computedClass,
    style: `${computedStyle ?? ""}${hidden ? " display: none" : ""}` || undefined,
};
$: if (propsWeControl.style === undefined) {
    delete propsWeControl.style;
}
</script>

{#if show}
  {#if typeof as === "string"}
    <svelte:element
      this={as}
      bind:this={el}
      use:useActions={use}
      use:forwardEvents
      {...$$restProps}
      {...propsWeControl}
      hidden={hidden || undefined}
    >
      <slot />
    </svelte:element>
  {:else}
    <svelte:component
      this={as}
      bind:el
      use={[...use, forwardEvents]}
      {...$$restProps}
      {...propsWeControl}
      hidden={hidden || undefined}
    >
      <slot />
    </svelte:component>
  {/if}
{/if}
